export enum EnumVisitMode {
  Inspection,
  Financial,
  Historical,
  Payable,
  Overdue,
}
